import React, { useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../Common/Pagination";
import MailTemplateList from "./MailTemplateList";
import MailTemplateForm from "./MailTemplateForm";
import PopupModal from "../Common/Popup";
import "./style.scss";

const MailTemplateBlock = ({ workspaceId }) => {
  const [count, setCount] = useState(0);
  const [limit] = useState(20);
  const [loading, setLoading] = useState(true);
  const [popupShow, setPopupShow] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(0);

  const handleCreate = () => {
    setSelectedTemplate(null);
    setPopupShow(true);
  };

  return (
    <>
      <Row>
        <Col md={12}>
          <div className="my-3 p-3 bg-body rounded shadow-sm feature-box">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
              <h6 className="heading mb-0">Mail Templates</h6>
              <Button variant="primary" size="sm" onClick={handleCreate}>
                <FontAwesomeIcon className="me-2" icon={faPlus} />
                Create Template
              </Button>
            </div>

            <div className="d-flex justify-content-end highlight-form-box border p-2 list-pagination-toolbar">
              <Col md="auto">
                <Pagination
                  page={page}
                  setPage={setPage}
                  count={count}
                  limit={limit}
                  setLoading={setLoading}
                />
              </Col>
            </div>

            <MailTemplateList
              workspaceId={workspaceId}
              page={page}
              setCount={setCount}
              limit={limit}
              loading={loading}
              setLoading={setLoading}
              setSelectedTemplate={setSelectedTemplate}
              setPopupShow={setPopupShow}
              reload={reload}
            />
          </div>
        </Col>
      </Row>

      <PopupModal
        title={selectedTemplate ? "Edit Mail Template" : "Create Mail Template"}
        popupShow={popupShow}
        setPopupShow={setPopupShow}
        size="xl"
        dialogClassName="mail-template-modal"
        bodyClassName="mail-template-modal-body"
      >
        <MailTemplateForm
          workspaceId={workspaceId}
          setPopupShow={setPopupShow}
          refreshList={() => {
            setPage(1);
            setReload((prev) => prev + 1);
          }}
          selectedTemplate={selectedTemplate}
        />
      </PopupModal>
    </>
  );
};

export default MailTemplateBlock;
